export default __webpack_public_path__ + "static/media/cupcakes.940ea1b8.jpg";